import { defineMessages } from 'react-intl';

export default defineMessages({
    bankInfo: {
        id: 'twia.agency.admin.eftpayments.bankInfoMsg',
        defaultMessage: 'Bank Account information is not required if you are only changing the EFT Payment Enrollment Contact',
    },
    contactInfoMsg: {
        id: "agent.admin.views.contactInfoMsg",
        defaultMessage: "This information is required by our financial institution and may be used to contact you."
     },
     addressLine1: {
        id: "agent.admin.views.eft.addressLine1",
        defaultMessage: "Address Line 1"
     },
     address: {
        id: "agent.admin.views.eft.address",
        defaultMessage: "Address"
     },
     businessChecking: {
        id: 'twia.gateway.views.selfservice.eftpayments.businessChecking',
        defaultMessage: 'This application does not support Business Savings'
    }
});
